import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import aiLogo from "../assets/img/ai-logo.png";
import continenteLogo from "../assets/img/continente-logo.png";
import continenteTitleMain from "../assets/img/continente-title-main.png";
import { AppDispatch } from "../redux/store";
import { loadProducts, loadStores } from "../redux/reducer";

const LOADING_DURATION = 5000; // 10 seconds total
const BACKGROUND_COLOR = "#EB0203";

const OpeningPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const [progress, setProgress] = useState(0);
    const intervalRef = React.useRef<ReturnType<typeof setInterval> | null>(null);

    useEffect(() => {
        dispatch(loadProducts());
        dispatch(loadStores());
    }, [dispatch]);

    useEffect(() => {

        // Progress bar animation and automatic navigation after 10 seconds
        const startTime = Date.now();
        intervalRef.current = setInterval(() => {
            const elapsed = Date.now() - startTime;
            const newProgress = Math.min((elapsed / LOADING_DURATION) * 100, 100);
            setProgress(newProgress);

            if (newProgress >= 100) {
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
                navigate("/cart");
            }
        }, 16); // Update approximately every 16ms for smooth animation

        return () => {
            const id = intervalRef.current;
            if (id !== null) {
                clearInterval(id);
            }
            intervalRef.current = null;
        };
    }, [navigate]);


    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                backgroundColor: BACKGROUND_COLOR,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                overflow: "hidden",
                padding: "32px 20px",
                boxSizing: "border-box",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    flex: 1,
                }}
            >
                <img
                    src={aiLogo}
                    alt="AI Logo"
                    style={{
                        width: "75px",
                        height: "75px",
                        objectFit: "contain",
                        marginBottom: "1.5rem",
                    }}
                />
                <img
                    src={continenteLogo}
                    alt="Continente logo"
                    style={{
                        width: "180px",
                        height: "auto",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                    }}
                />
                <img
                    src={continenteTitleMain}
                    alt="Assist title"
                    style={{
                        width: "90px",
                        height: "auto",
                        objectFit: "contain",
                    }}
                />
            </Box>

            {/* Loading bar at the bottom - always visible */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                }}
            >
                <Box
                    sx={{
                        height: "100%",
                        width: `${progress}%`,
                        backgroundColor: "#FFFFFF",
                        transition: "width 0.1s linear",
                    }}
                />
            </Box>
        </Box>
    );
};

export default OpeningPage;
